'use strict';

module.exports = (element, index) => typeof element !== 'undefined' && element !== null;